import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import PartnersState from '../../types/PartnersState'
import Partner from "../../types/Partner";

const mutations: MutationTree<PartnersState> = {
  [types.SET_PARTNERS] (state, payload: Partner[]) {
    state.partners = payload
  },
  [types.SET_CURRENT_PARTNER_CODE] (state, payload: string) {
    state.current_partner_code = payload
  },
  [types.RESET_CURRENT_PARTNER_CODE] (state) {
    state.current_partner_code = null
  },
  [types.SET_FILTER_PARTNER] (state, partner) {
    // K2-2817: never let the `anywhere` pseudo-partner into a browsable list (see
    // getPartnersByLocation) - the tag-filter endpoint can still return it on an
    // untagged call since `anywhere` is now `enabled: true`.
    state.filterPartners = Array.isArray(partner) ? partner.filter(p => p.code !== 'anywhere') : partner
    state.showFilterPartners = true
  },
  [types.SET_HIDDEN_FILTER_PARTNERS] (state) {
    state.showFilterPartners = false
    state.filterPartners = []
  },
  // Upsert by code + location (codes like `anywhere` repeat per city): a full doc
  // replaces a trimmed one and refreshes `open`; a trimmed one never replaces a full one.
  [types.ADD_PARTNERS] (state, payload: Partner[]) {
    payload.forEach(p => {
      const i = state.partners.findIndex(partner => partner.code === p.code && partner.location_code === p.location_code)
      if (i === -1) {
        state.partners.push(p)
      } else if (!p._partial || state.partners[i]._partial) {
        state.partners.splice(i, 1, p)
      }
    })
  },
  [types.SET_LIST_SCOPE] (state, payload: string | null) {
    state.listScope = payload
  },
  [types.ON_OR_OFF_LOADER] (state, value) {
    state.partnerLoader = value
  },
  [types.SET_CATEGORY_SEO_STATS] (state, payload) {
    state.categorySeoStats = payload
  }
}

export default mutations
